/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Refunds__ConfirmationInputs */

const en_help_center__refund_policy__refunds__confirmation = /** @type {((inputs: Help_Center__Refund_Policy__Refunds__ConfirmationInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Refunds__ConfirmationInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Refunds__ConfirmationInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Confirmation: You will receive an email confirmation once your refund has been processed.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Refunds__ConfirmationInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Confirmation:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " You will receive an email confirmation once your refund has been processed." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Confirmation: You will receive an email confirmation once your refund has been processed." |
*
* @param {Help_Center__Refund_Policy__Refunds__ConfirmationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__refunds__confirmation = /** @type {((inputs?: Help_Center__Refund_Policy__Refunds__ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Refunds__ConfirmationInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Refunds__ConfirmationInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Refunds__ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__refunds__confirmation(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Refunds__ConfirmationInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__refunds__confirmation.parts === "function" ? en_help_center__refund_policy__refunds__confirmation.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__refunds__confirmation(inputs) }]
			})
		}
	)
);